export type ConsentCategories = Record<ConsentCategory, boolean>

export const NO_CONSENT: ConsentCategories = {
  necessary: true,
  functional: false,
  analytics: false,
  performance: false,
  advertisement: false,
}

export function categoriesFromCkyConsent(consent: CkyConsent | undefined): ConsentCategories {
  return { ...NO_CONSENT, ...consent?.categories }
}

export function categoriesFromConsentUpdate(detail: ConsentUpdateEventData): ConsentCategories {
  const accepted = new Set(detail.accepted)
  return {
    necessary: true,
    functional: accepted.has('functional'),
    analytics: accepted.has('analytics'),
    performance: accepted.has('performance'),
    advertisement: accepted.has('advertisement'),
  }
}

export function keysWithPrefix(keys: readonly string[], prefixes: readonly string[]): string[] {
  return keys.filter(key => prefixes.some(prefix => key.startsWith(prefix)))
}

export function purgeStorage(prefixes: readonly string[]): void {
  for (const storage of [localStorage, sessionStorage]) {
    for (const key of keysWithPrefix(Object.keys(storage), prefixes)) {
      storage.removeItem(key)
    }
  }
}
